<template>
    <div
        class="add-step-btn"
        @click="$emit('click')">
        <pendo-icon
            type="plus"
            size="12" />
    </div>
</template>

<script>
import { PendoIcon } from '@pendo/components';

export default {
    name: 'AddStepButton',
    components: {
        PendoIcon,
    },
    emits: ['click'],
};
</script>

<style lang="less">
.add-step-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 28px;
    width: 28px;
    border-radius: 3px;
    padding: 8px;
    border: 1px solid var(--palette-gray-40);
    background: var(--palette-gray-0);

    &:hover {
        border: 1px solid var(--palette-blue-60);
    }
}
</style>
